import { render, staticRenderFns } from "./GameExamine.vue?vue&type=template&id=6e8f3448"
import script from "./GameExamine.vue?vue&type=script&lang=js"
export * from "./GameExamine.vue?vue&type=script&lang=js"
import style0 from "./GameExamine.vue?vue&type=style&index=0&id=6e8f3448&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports